module.exports = __webpack_public_path__ + "static/media/marketing-icon.eac2436e.svg";